// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-menu {
  position: fixed;  
  top: 0; 
  left: 0; 
  width: 100%; 
  display: flex;
  justify-content: space-between;
  background-color: #333;
  color: #fff;
  padding: 10px;
  z-index: 1000; 
  align-items: center; 
}

.menu-toggle {
  display: none; 
  background-color: #333;
  color: #fff;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
}

.tabs-container {
  display: flex;
  flex-wrap: wrap; 
  flex: 1 1; 
}

.tab {
  cursor: pointer;
  padding: 10px 20px;
  border-bottom: 3px solid transparent;
  transition: border-color 0.3s, background-color 0.3s;
  text-align: center; 
  flex: 1 1; 
}

/* Pantallas grandes */
@media (min-width: 601px) {
  .tab.active {
    border-color: green; 
    background-color: transparent; 
  }
}

/* Pantallas pequeñas */
@media (max-width: 600px) {
  .menu-toggle {
    display: block; 
  }

  .tabs-container {
    display: none; 
    flex-direction: column; 
    width: 100%; 
  }

  .tabs-container.show {
    display: flex; 
  }

  .tab {
    padding: 15px; 
    font-size: 18px; 
  }

  .tab.active {
    border-color: green; 
    background-color: #444; 
  }
}

.content {
  margin-top: 60px; 
}
`, "",{"version":3,"sources":["webpack://./src/css/tabMenu.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,oDAAoD;EACpD,kBAAkB;EAClB,SAAO;AACT;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".tab-menu {\n  position: fixed;  \n  top: 0; \n  left: 0; \n  width: 100%; \n  display: flex;\n  justify-content: space-between;\n  background-color: #333;\n  color: #fff;\n  padding: 10px;\n  z-index: 1000; \n  align-items: center; \n}\n\n.menu-toggle {\n  display: none; \n  background-color: #333;\n  color: #fff;\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.tabs-container {\n  display: flex;\n  flex-wrap: wrap; \n  flex: 1; \n}\n\n.tab {\n  cursor: pointer;\n  padding: 10px 20px;\n  border-bottom: 3px solid transparent;\n  transition: border-color 0.3s, background-color 0.3s;\n  text-align: center; \n  flex: 1; \n}\n\n/* Pantallas grandes */\n@media (min-width: 601px) {\n  .tab.active {\n    border-color: green; \n    background-color: transparent; \n  }\n}\n\n/* Pantallas pequeñas */\n@media (max-width: 600px) {\n  .menu-toggle {\n    display: block; \n  }\n\n  .tabs-container {\n    display: none; \n    flex-direction: column; \n    width: 100%; \n  }\n\n  .tabs-container.show {\n    display: flex; \n  }\n\n  .tab {\n    padding: 15px; \n    font-size: 18px; \n  }\n\n  .tab.active {\n    border-color: green; \n    background-color: #444; \n  }\n}\n\n.content {\n  margin-top: 60px; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
